import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../../boot";

export const getCollectionList = createAsyncThunk("utils/category-list", async (payload) => {
  try {
    const response = await axios.post(`${baseUrl}utils/api/v1/category-list`, { payload });
    return response;
  } catch (error) {
    throw error;
  }
});
